(function($){
  $.fn.moveTo = function(selector){
    return this.each(function(){
      var cl = $(this).clone();
      $(cl).appendTo(selector);
      $(this).remove();

    });
  };
})(jQuery);


jQuery(function() {
  if(jQuery('#rev_slider').length > 0)
    jQuery('#rev_slider').show().revolution({
      dottedOverlay: 'none',
      delay: 10000,
      startwidth: 1920,
      startheight: 996,

      autoHeight:"on",
      fullScreenAlignForce:"off",

      onHoverStop:"on",

      thumbWidth:100,
      thumbHeight:50,
      thumbAmount:3,

      hideThumbsOnMobile:"off",
      hideBulletsOnMobile:"off",
      hideArrowsOnMobile:"off",
      hideThumbsUnderResoluition:0,

      hideTimerBar:"on",
      hideThumbs:0,

      navigationType:"bullet",
      navigationArrows:"solo",
      navigationStyle:"round",

      navigationHAlign:"center",
      navigationVAlign:"bottom",
      navigationHOffset:0,
      navigationVOffset:15,

      soloArrowLeftHalign:"left",
      soloArrowLeftValign:"center",
      soloArrowLeftHOffset:40,
      soloArrowLeftVOffset:0,

      soloArrowRightHalign:"right",
      soloArrowRightValign:"center",
      soloArrowRightHOffset:40,
      soloArrowRightVOffset:0,


      touchenabled:"on",

      stopAtSlide:-1,
      stopAfterLoops:-1,
      hideCaptionAtLimit:0,
      hideAllCaptionAtLilmit:0,
      hideSliderAtLimit:0,

      dottedOverlay:"none",

      fullWidth:"on",
      forceFullWidth:"off",
      
      fullScreen:"on",
      
      fullScreenOffsetContainer:"#topheader-to-offset",

      shadow:0
    });
  
  $('.main-slider').css('display','block');
  /* End Home Slider */
});